export default { trainings: state => state.trainings }
